import * as React from 'react';
import ReactDatePicker from 'react-datepicker';
import { Icon } from '@teamsnap/teamsnap-ui';
import './date-picker.scss';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const createDateString = (date: Date) =>
  date?.toLocaleDateString('en-us', { year: 'numeric', month: 'numeric', day: 'numeric' });

const CustomDatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => (
  <div className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween u-spaceBottomMd">
    <button className="u-colorNeutral9" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
      <Icon name="left" />
    </button>
    <div className="react-datepicker__current-month u-colorNeutral9">{ `${
      months[date.getMonth()]
    } ${date.getFullYear()}` }
    </div>
    <button className="u-colorNeutral9" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
      <Icon name="right" />
    </button>
  </div>
);

interface Props {
  start: Date
  end: Date
  setDates: (x: { start: Date, end: Date }) => void
}

const DatePicker = ({ start, end, setDates }: Props) => {
  const [mode, setMode] = React.useState<'start' | 'end'>('start');

  const onChange = (date: Date) => {
    setDates({
      start: mode === 'start' ? date : start,
      end: mode === 'end' ? date : end
    })
  }

  return (
    <div className="date-picker Grid-cell" data-testid="date-range-picker">
      <div className='u-flex u-flexJustifyBetween'>
        <div className='u-size11of24'>
          <button
            data-testid="date-range-picker-toggle-start"
            className={`u-sizeFull ${
              mode === 'start' ? 'opened' : ''
            } u-colorNeutral9 btn-date-range-toggle u-flex u-flexRow u-flexAlignItemsCenter u-flexJustifyBetween`}
            onClick={() => setMode('start')}
            type="button"
          >
            <span className="u-colorNeutral9">
              { createDateString(start) }
            </span>
            <Icon name="calendar-today" />
          </button>
        </div>

        <div className='u-size11of24'>
          <button
            data-testid="date-range-picker-toggle-end"
            className={`u-sizeFull ${
              mode === 'end' ? 'opened' : ''
            } u-colorNeutral9 btn-date-range-toggle u-flex u-flexRow u-flexAlignItemsCenter u-flexJustifyBetween`}
            onClick={() => setMode('end')}
            type="button"
          >
            <span className="u-colorNeutral9">
              { createDateString(end) }
            </span>
            <Icon name="calendar-today" />
          </button>
        </div>
      </div>
    
      <div className="calendar-popup__container Grid-cell">
        <div data-testid="date-range-picker-calendar" className="calendar-popup">
          <ReactDatePicker
            allowSameDay={true}
            onChange={onChange}
            selected={mode === 'start' ? start : end}
            maxDate={mode === 'start' ? end : undefined}
            minDate={mode === 'end' ? start : undefined}
            renderCustomHeader={(props) => <CustomDatePickerHeader {...props} />}
            inline
          />
        </div>
      </div>
    </div>
  );
};

export default DatePicker
